import { useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { Alert, Button, Card, CardBody, FormGroup, Input, Label } from "reactstrap";
import { updateUserSettings } from "../../graphql/user/updateUserDetails";
import { useUserSettingsWithOrganisation } from "../../hooks/useUserDetails";
import toast from "react-hot-toast";

const UserSettingsPage = () => {

    const [nudgeInteraction, setNudgeInteraction] = useState<boolean>(true);
    const [nudgeDelay, setNudgeDelay] = useState<number>(120);
    const [isOnProcess, setIsOnProcess] = useState<boolean>(false);
    const [isAllowed, setIsAllowed] = useState<boolean>(false);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);

    const { data, loading, error } = useUserSettingsWithOrganisation();

    const [updateUserSettingsHook] = useMutation(updateUserSettings,{
        onCompleted : () =>{
            toast.success("Settings updated successfully, some changes will take effect on your next working day");
        },
        onError : () =>{
            toast.error("Something went wrong whilst updating your settings . Please try again or if issue persists, please contact us");
        }
    });

    const HandleUpdate = async () => {
        setIsOnProcess(true);
        await updateUserSettingsHook({
            variables : {
                nudge_delay : nudgeDelay,
                nudge_interaction : nudgeInteraction
            }
        }).then((res) => res.errors ? false : true).catch(() => false);

        setIsOnProcess(false);
    }

    useEffect(() => {
        if(data) {
            if(data.me.organisation && data.me.organisation.allow_user_customisation === true) {
                setNudgeDelay(Number(data.me.nudge_delay));
                setNudgeInteraction(data.me.nudge_interaction || false);
                setIsAllowed(true);
            }
            else {
                setNudgeDelay(Number(data.me.organisation.nudge_delay));
                setNudgeInteraction(data.me.organisation.nudge_interaction || false);
            }

            setIsLoaded(true);
        }
    },[data]);

    return (<>
        <Card>
            <CardBody>
                {
                    error &&
                    <Alert color="danger">Error on getting your settings, Please try again or if issue persists, please contact us</Alert>
                }
                {
                    !isAllowed && isLoaded &&
                    <Alert color="warning">Your organisation has disabled customisation of nudge settings</Alert>
                }
                <fieldset disabled={loading || !isAllowed}>
                    <FormGroup>
                        <Label>Nudge Delay</Label>
                        <Input type="select" value={nudgeDelay} onChange={(e) => setNudgeDelay(Number(e.currentTarget.value))} >
                            <option value="60">1 Hour</option>
                            <option value="120">2 Hours (Default)</option>
                            <option value="240">4 Hours</option>
                        </Input>
                        <small className="text-muted">Set the delay interval for your nudges</small>
                    </FormGroup>
                    <FormGroup>
                        <label>Nudge Interaction</label>
                        <div>
                            <small className="text-primary">NOTE: Changes from this will apply on your next working day. </small>
                        </div>
                        <Input type="select" value={nudgeInteraction.toString().toLowerCase()} onChange={(e)=>setNudgeInteraction(e.currentTarget.value === "true")} >
                            <option value="true">ON (Default)</option>
                            <option value="false">OFF</option>
                        </Input>
                        <small className="text-muted">This option controls how nudges behave. If turned off, nudges will proceed without any interaction from you. </small>
                    </FormGroup>

                    <div className="d-flex justify-content-end">
                        <Button color="primary" disabled={isOnProcess || loading} onClick={HandleUpdate}>Save</Button>
                    </div>
                </fieldset>
            </CardBody>
        </Card>
    </>);
}


export { UserSettingsPage as UserSettings };